// frontend/src/components/RatingForm.js
import React, { useState, useEffect } from 'react';
import CustomStarRating from './CustomStarRating'; // Ensure this import is correct
import axios from 'axios';

const RatingForm = ({ orderId, onSuccess }) => {
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState('');
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    console.log('RatingForm mounted for orderId:', orderId);
  }, [orderId]);

  const handleSubmit = async () => {
    if (rating === 0) {
      setError('Please select a star rating.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/order/${orderId}/rate/`,
        { rating, review, is_anonymous: isAnonymous },
        { withCredentials: true }
      );
      console.log('Rating submission response:', response.data);
      alert('Rating submitted successfully!');
      onSuccess();
    } catch (err) {
      console.error('Rating submission failed:', err.response?.data || err.message);
      const errorMsg = err.response?.data?.error || 'Failed to submit rating. Please try again.';
      setError(errorMsg);
    } finally {
      setSubmitting(false);
    }
  };

  console.log('RatingForm rendering with rating:', rating);

  return (
    <div className="p-4 bg-gray-800 rounded mb-4 rating-form-container">
      <h3 className="text-lg font-semibold text-white mb-2">Rate This Service</h3>
      <p className="text-sm text-gray-400 mb-2">
        Your rating helps providers improve and informs other clients. Higher ratings increase a provider’s visibility!
      </p>
      <div className="mb-2">
        <CustomStarRating
          count={5}
          value={rating}
          onChange={(newRating) => {
            console.log('Star rating changed to:', newRating);
            setRating(newRating);
            setError('');
          }}
        />
        {rating === 0 && <p className="text-gray-400 text-sm mt-1">Click to rate (1-5 stars)</p>}
      </div>
      <textarea
        className="w-full p-2 mt-2 bg-gray-700 text-white rounded"
        placeholder="Leave a review (optional)"
        value={review}
        onChange={(e) => setReview(e.target.value)}
      />
      <label className="flex items-center mt-2 text-white">
        <input
          type="checkbox"
          checked={isAnonymous}
          onChange={(e) => setIsAnonymous(e.target.checked)}
          className="mr-2"
        />
        Post anonymously
      </label>
      {error && <p className="text-red-500 mt-2">{error}</p>}
      <button
        className={`btn btn-small btn-purple mt-2 ${submitting ? 'bg-gray-600 cursor-not-allowed' : ''}`}
        onClick={handleSubmit}
        disabled={submitting || rating === 0}
      >
        {submitting ? 'Submitting...' : 'Submit Rating'}
      </button>
    </div>
  );
};

export default RatingForm;
